export default function postBulkDomainReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'POST_BULK_DOMAIN_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'POST_BULK_DOMAIN_ERROR':
      return {...state, ...{error: action.error}};

    case 'POST_BULK_DOMAIN_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}